// eslint-disable-next-line max-lines-per-function
define( [ 'utility' ], function run( utility ) {
	'use strict';

	var carouselNumber = 0;

	var oCarouselFn = {

		defaults : {
			smallSlides : 1,
			mediumSlides : 2,
			largeSlides : 4,
			labels : {
				carouselLabel : FRAMEWORK.locale.settings.oCarousel.carouselLabel,
				previousPageLong : FRAMEWORK.locale.settings.oCarousel.previousPageLong,
				previousPage : FRAMEWORK.locale.settings.oCarousel.previousPage,
				page : FRAMEWORK.locale.settings.oCarousel.page,
				nextPageLong : FRAMEWORK.locale.settings.oCarousel.nextPageLong,
				nextPage : FRAMEWORK.locale.settings.oCarousel.nextPage,
				slide : FRAMEWORK.locale.settings.oCarousel.slide,
			},
			type : {
				card : {
					class : '.m-card',
					peekabooMargin : [ 20, 20, 0 ],
					slideMargin : [ 20, 20, 30 ],
				},
				standard : {
					class : '.o-carousel__item',
					peekabooMargin : [ 0, 0, 0 ],
					slideMargin : [ 20, 20, 30 ],
				},
				basic : {
					class : '.o-carousel__item',
					peekabooMargin : [ 0, 0, 0 ],
					slideMargin : [ 0, 0, 0 ],
				},
			},
		},

		init : function( elm, extras ) {
			var onResize,
				onRefresh;

			if ( !elm.classList.contains( 'js-o-carousel' ) ) {
				elm.classList.add( 'js-o-carousel' );

				// Set settings from defaults and any specified options
				elm.oCarousel = {};
				elm.oCarousel.settings = utility.extend({}, oCarouselFn.defaults, utility.getData( elm ) );
				elm.oCarousel.settings.scrollLock = false;

				if ( typeof elm.oCarousel.settings.slides !== 'undefined' ) {
					elm.oCarousel.settings.smallSlides = elm.oCarousel.settings.slides[ 0 ];
					elm.oCarousel.settings.mediumSlides = elm.oCarousel.settings.slides[ 1 ];
					elm.oCarousel.settings.largeSlides = elm.oCarousel.settings.slides[ 2 ];
				}

				if ( extras ) {
					elm.oCarousel = utility.extend( elm.oCarousel, extras );
				}

				if ( elm.classList.contains( 'o-carousel--standard' ) ) {
					elm.oCarousel.settings.slideSelector = elm.oCarousel.settings.type.standard.class;
					elm.oCarousel.settings.peekabooMargin = elm.oCarousel.settings.type.standard.peekabooMargin;
					elm.oCarousel.settings.slideMargin = elm.oCarousel.settings.type.standard.slideMargin;
				} else if ( elm.classList.contains( 'o-carousel--basic' ) ) {
					elm.oCarousel.settings.slideSelector = elm.oCarousel.settings.type.basic.class;
					elm.oCarousel.settings.peekabooMargin = elm.oCarousel.settings.type.basic.peekabooMargin;
					elm.oCarousel.settings.slideMargin = elm.oCarousel.settings.type.basic.slideMargin;
				} else {
					elm.classList.add( 'o-carousel--card' );
					elm.oCarousel.settings.slideSelector = elm.oCarousel.settings.type.card.class;
					elm.oCarousel.settings.peekabooMargin = elm.oCarousel.settings.type.card.peekabooMargin;
					elm.oCarousel.settings.slideMargin = elm.oCarousel.settings.type.card.slideMargin;
				}

				elm.oCarousel.currentBreakpoint = utility.getBreakpoint();
				elm.oCarousel.currentBreakpointString = 'large';
				elm.oCarousel.settings.slideCount = elm.querySelectorAll( elm.oCarousel.settings.slideSelector ).length;
				elm.oCarousel.settings.slidesPerGroup = elm.oCarousel.settings.largeSlides;
				elm.oCarousel.settings.uniqueId = utility.makeId( 'o-carousel-' );

				oCarouselFn.breakpoint( elm );

				onResize = utility.debounce( function listener() {
					var newBreakpoint = utility.getBreakpoint();
					if ( newBreakpoint !== elm.oCarousel.currentBreakpoint ) {
						elm.oCarousel.currentBreakpoint = newBreakpoint;
						oCarouselFn.breakpoint( elm );
						if ( elm.classList.contains( 'js-o-carousel--active' ) && utility.isVisible( elm ) ) {
							oCarouselFn.update( elm );
						}
					} else if ( elm.classList.contains( 'js-o-carousel--active' ) && utility.isVisible( elm ) ) {
						oCarouselFn.resize( elm );
					} else {
						// Do nothing
					}
				}, 10 );
				onRefresh = utility.debounce( function listener() {
					if ( elm.classList.contains( 'js-o-carousel--active' ) && utility.isVisible( elm ) ) {
						oCarouselFn.update( elm );
					}
				}, 10 );

				window.addEventListener( 'resize', onResize );
				window.addEventListener( 'refresh', onRefresh );

				// Move to the next group of slides
				elm.oCarousel.nextSlide = function nextSlide() {
					oCarouselFn.setSlidePosition( elm, elm.oCarousel.nextPageIndex );
				};
				// Move to the previous group of slides
				elm.oCarousel.previousSlide = function previousSlide() {
					oCarouselFn.setSlidePosition( elm, elm.oCarousel.previousPageIndex );
				};
				// Move to a specific slide containing the card specifid by its index
				elm.oCarousel.gotoSlide = function gotoSlide( slideReference ) {
					var newSlideReference = slideReference,
						selectedSlide,
						newSlideIndex;

					if ( typeof slideReference === 'string' ) {
						// If the slide reference is a string search for the card by its ID
						newSlideReference = Array.prototype.slice.call( elm.oCarousel.allCards ).indexOf( elm.querySelector( slideReference ) );
						selectedSlide = elm.oCarousel.allCards[ newSlideReference ];
					} else if ( typeof slideReference === 'number' ) {
						// If the slide reference is an index for the card get the card by its index
						if ( slideReference < 1 ) {
							// Do nothing just go to the first slide
							newSlideReference = 1;
						} else if ( slideReference > elm.oCarousel.settings.slideCount ) {
							// If the number provided is greater than the number of slide move to the last slide
							newSlideReference = elm.oCarousel.settings.slideCount;
						}

						selectedSlide = elm.oCarousel.allCards[ newSlideReference - 1 ];
					} else {
						// Do nothing
					}
					if ( selectedSlide ) {
						newSlideIndex = Array.prototype.slice.call( elm.oCarousel.allSlides ).indexOf( selectedSlide.closest( '.o-carousel-slide' ) );
						oCarouselFn.setSlidePosition( elm, newSlideIndex );
					}
				};
			}

			return elm.oCarousel;
		},

		breakpoint : function( elm ) {
			elm.oCarousel.currentBreakpointString = 'large';
			elm.oCarousel.currentPeekabooMargin = elm.oCarousel.settings.peekabooMargin[ 2 ];
			elm.oCarousel.currentSlideMargin = elm.oCarousel.settings.slideMargin[ 2 ];

			if ( elm.oCarousel.currentBreakpoint === utility.smallTag ) {
				elm.oCarousel.currentBreakpointString = 'small';
				elm.oCarousel.currentPeekabooMargin = elm.oCarousel.settings.peekabooMargin[ 0 ];
				elm.oCarousel.currentSlideMargin = elm.oCarousel.settings.slideMargin[ 0 ];
				if ( elm.oCarousel.settings.smallSlides !== 0 && elm.oCarousel.settings.slideCount > elm.oCarousel.settings.smallSlides ) {
					elm.oCarousel.settings.slidesPerGroup = elm.oCarousel.settings.smallSlides;
					oCarouselFn.update( elm );
				} else {
					oCarouselFn.destroy( elm );
				}
			} else if ( elm.oCarousel.currentBreakpoint === utility.mediumTag ) {
				elm.oCarousel.currentBreakpointString = 'medium';
				elm.oCarousel.currentPeekabooMargin = elm.oCarousel.settings.peekabooMargin[ 1 ];
				elm.oCarousel.currentSlideMargin = elm.oCarousel.settings.slideMargin[ 1 ];
				if ( elm.oCarousel.settings.mediumSlides !== 0 && elm.oCarousel.settings.slideCount > elm.oCarousel.settings.mediumSlides ) {
					elm.oCarousel.settings.slidesPerGroup = elm.oCarousel.settings.mediumSlides;
					oCarouselFn.update( elm );
				} else {
					oCarouselFn.destroy( elm );
				}
			} else if ( elm.oCarousel.settings.largeSlides !== 0 && elm.oCarousel.settings.slideCount > elm.oCarousel.settings.largeSlides ) {
				elm.oCarousel.settings.slidesPerGroup = elm.oCarousel.settings.largeSlides;
				oCarouselFn.update( elm );
			} else {
				oCarouselFn.destroy( elm );
			}
		},

		create : function( elm ) {
			var onScroll;

			carouselNumber += 1;

			if ( elm.oCarousel.preCreate && typeof elm.oCarousel.preCreate === 'function' ) {
				elm.oCarousel.preCreate();
			}

			elm.oCarousel.allCards = elm.querySelectorAll( elm.oCarousel.settings.slideSelector );

			// Wrap area to make scrollable
			elm.classList.add( 'js-o-carousel--active' );
			utility.wrapInner( elm, utility.htmlStringToElement( '<section class="o-carousel__scrollarea" tabindex="0" ' +
			'aria-label="' + elm.oCarousel.settings.labels.carouselLabel + ' ' + carouselNumber + '"></section >' ) );

			elm.oCarousel.scrollarea = elm.querySelector( '.o-carousel__scrollarea' );

			// Setup pagination
			elm.oCarousel.pagination = utility.htmlStringToElement( '<div class="o-carousel-pagination">' +
				'<ul class="o-carousel-pagination-list a-list-plain">' +
				'<li class="o-carousel__previous"><button class="o-carousel-nextprev" type="button" tabindex="-1"><span>' + elm.oCarousel.settings.labels.previousPage +
				'</span></button></li>' +
				'<li class="o-carousel__next"><button class="o-carousel-nextprev" type="button" tabindex="-1"><span>' + elm.oCarousel.settings.labels.nextPage + '</span></button></li>' +
				'</ul>' +
				'</div>' );

			// Setup previous and next buttons
			elm.oCarousel.previousPageIndex = 0;
			elm.oCarousel.nextPageIndex = 1;
			elm.oCarousel.previousButton = elm.oCarousel.pagination.querySelector( '.o-carousel__previous' );
			elm.oCarousel.nextButton = elm.oCarousel.pagination.querySelector( '.o-carousel__next' );

			if ( elm.oCarousel.prevArrow ) {
				elm.oCarousel.previousButton.innerHTML = elm.oCarousel.prevArrow;
			}
			if ( elm.oCarousel.nextArrow ) {
				elm.oCarousel.nextButton.innerHTML = elm.oCarousel.nextArrow;
			}

			elm.oCarousel.previousButton.firstChild.addEventListener( 'click', function listener() {
				oCarouselFn.setSlidePosition( elm, elm.oCarousel.previousPageIndex );
			});
			elm.oCarousel.nextButton.firstChild.addEventListener( 'click', function listener() {
				oCarouselFn.setSlidePosition( elm, elm.oCarousel.nextPageIndex );
			});

			// Append the pagination
			elm.append( elm.oCarousel.pagination );

			// Build slide and set the initial position so the pagination is correct
			oCarouselFn.buildSlides( elm );
			oCarouselFn.setSlidePosition( elm, 0 );

			onScroll = utility.debounce( function listener() {
				var index = Math.round( elm.oCarousel.scrollarea.scrollLeft / elm.oCarousel.slideWidth );
				oCarouselFn.setSlidePosition( elm, index, true );
			}, 50 );
			elm.oCarousel.scrollarea.addEventListener( 'scroll', onScroll );
		},

		buildSlides : function( elm ) {
			var i,
				j,
				currentSlide,
				currentSlideInner,
				newPaginationButton,
				newPaginationButtonText,
				slideId;

			elm.oCarousel.numberOfSlides = Math.ceil( elm.oCarousel.settings.slideCount / elm.oCarousel.settings.slidesPerGroup );

			if ( elm.oCarousel.numberOfSlides > 1 ) {
				// If there are already slides then destroy them and start again
				if ( elm.querySelector( '.o-carousel-slide' ) ) {
					oCarouselFn.destroySlides( elm );
				}

				// Loop through all the number of slides needed and set them up
				for ( i = 0; i < elm.oCarousel.numberOfSlides; i++ ) {
					slideId = elm.oCarousel.settings.uniqueId + '-slide' + i;
					newPaginationButtonText = elm.oCarousel.settings.labels.page.replace( '{x}', i + 1 );
					newPaginationButtonText = newPaginationButtonText.replace( '{y}', elm.oCarousel.numberOfSlides );
					currentSlide = utility.htmlStringToElement( '<div class="o-carousel-slide" id="' +
						slideId + '" role="group" aria-roledescription="' + elm.oCarousel.settings.labels.slide + '" aria-label="' + newPaginationButtonText + '">' +
						'<div class="o-carousel-slide__inner l-columns l-columns--' +
						elm.oCarousel.settings.slidesPerGroup + '-' + elm.oCarousel.currentBreakpointString + '"></div></div>' );
					currentSlideInner = currentSlide.firstChild;

					// Add cards to each slide
					for ( j = 0; j < elm.oCarousel.settings.slidesPerGroup && ( ( i * elm.oCarousel.settings.slidesPerGroup ) + j ) < elm.oCarousel.settings.slideCount; j++ ) {
						currentSlideInner.append( elm.oCarousel.allCards[ ( i * elm.oCarousel.settings.slidesPerGroup ) + j ] );
					}
					elm.oCarousel.scrollarea.append( currentSlide );

					// Create and add pagination link for slide
					newPaginationButton = utility.htmlStringToElement( '<li class="o-carousel-pagination-list__item"><button type="button" tabindex="-1" aria-controls="' +
					slideId + '"><span>' + newPaginationButtonText + '</span></button></li>' );
					oCarouselFn.setPaginationListener( elm, newPaginationButton.firstChild, i );
					elm.oCarousel.pagination.firstChild.insertBefore( newPaginationButton, elm.oCarousel.nextButton );
				}

				elm.oCarousel.allSlides = elm.querySelectorAll( '.o-carousel-slide' );

				oCarouselFn.resize( elm ); // Make sure the slide are the correct size
			} else {
				oCarouselFn.destroy( elm ); // If only one slide destory the carousel
			}
		},

		destroySlides : function( elm ) {
			// Move all cards out of slides so they are safe
			elm.oCarousel.allCards.forEach( function loop( individualCard ) {
				elm.oCarousel.scrollarea.append( individualCard );
			});
			// Remove all the slides
			elm.oCarousel.allSlides.forEach( function loop( individualSlide ) {
				individualSlide.remove();
			});
			// Remove all pagination buttons
			elm.oCarousel.pagination.querySelectorAll( '.o-carousel-pagination-list__item' ).forEach( function loop( individualPaginationItem ) {
				individualPaginationItem.remove();
			});
		},

		update : function( elm ) {
			if ( elm.classList.contains( 'js-o-carousel--active' ) ) {
				oCarouselFn.buildSlides( elm );
				oCarouselFn.setSlidePosition( elm, 0, false, true );
			} else {
				oCarouselFn.create( elm );
			}
		},

		destroy : function( elm ) {
			if ( elm.classList.contains( 'js-o-carousel--active' ) ) {
				elm.oCarousel.allCards.forEach( function loop( individualCard ) {
					elm.append( individualCard );
				});
				elm.oCarousel.scrollarea.remove();
				elm.oCarousel.pagination.remove();
				elm.classList.remove( 'js-o-carousel--active' );
			}
			if ( elm.oCarousel.postDestroy && typeof elm.oCarousel.postDestroy === 'function' ) {
				elm.oCarousel.postDestroy();
			}
		},

		resize : function( elm ) {
			elm.oCarousel.slideWidth = elm.offsetWidth - ( 2 * ( elm.oCarousel.currentPeekabooMargin + elm.oCarousel.currentSlideMargin ) );
		},

		setSlidePosition : function( elm, index, disableScroll, forceUpdate ) {
			var smoothScrollSupported = 'scrollBehavior' in document.documentElement.style && document.documentElement.style.scrollBehavior !== 'auto',
				slideIndex = 0,
				currentPageLink,
				newPageLink,
				slidePosition,
				selectorString;

			if ( elm.oCarousel.settings.scrollLock && !smoothScrollSupported ) {
				// Prevent scolling when already scrolling
			} else {
				if ( index < elm.oCarousel.numberOfSlides ) {
					slideIndex = index;
				}
				if ( elm.classList.contains( 'js-o-carousel--active' ) && ( elm.oCarousel.currentIndex !== slideIndex || forceUpdate ) ) {
					elm.oCarousel.settings.scrollLock = true;
					elm.oCarousel.currentIndex = slideIndex;

					// Remove attributes for old selected slide
					currentPageLink = elm.oCarousel.pagination.querySelector( '.o-carousel-pagination-list__item button:disabled' );
					if ( currentPageLink ) {
						currentPageLink.removeAttribute( 'disabled' );
						currentPageLink.removeAttribute( 'aria-current' );
					}

					// Set attributes on newly selected slide
					newPageLink = elm.oCarousel.pagination.querySelector( '.o-carousel-pagination-list__item button[aria-controls="' + elm.oCarousel.settings.uniqueId + '-slide' + slideIndex + '"]' );
					newPageLink.disabled = true;
					newPageLink.setAttribute( 'aria-current', 'true' );

					// Update attributes on previous button
					oCarouselFn.updatePreviousButton( elm, slideIndex );

					// Update attributes on next button
					oCarouselFn.updateNextButton( elm, slideIndex );
					selectorString = '#' + elm.oCarousel.settings.uniqueId + '-slide' + slideIndex;

					slidePosition = elm.querySelector( selectorString ).offsetLeft - elm.oCarousel.currentPeekabooMargin - elm.oCarousel.currentSlideMargin;

					if ( disableScroll ) {
						// Do nothing
						elm.oCarousel.settings.scrollLock = false;
					} else {
						elm.oCarousel.scrollarea.scrollTo( slidePosition, 0 );
						elm.oCarousel.settings.scrollLock = false;
					}
				}
			}
		},

		updatePreviousButton : function( elm, slideIndex ) {
			var previousButton = elm.oCarousel.previousButton.firstChild,
				previousPageIndex,
				previousButtonLongText;

			if ( slideIndex > 0 ) {
				previousPageIndex = slideIndex - 1;
				previousButton.removeAttribute( 'disabled' );
			} else {
				previousPageIndex = 0;
				previousButton.disabled = true;
			}

			previousButtonLongText = elm.oCarousel.settings.labels.previousPageLong.replace( '{x}', previousPageIndex + 1 );
			previousButtonLongText = previousButtonLongText.replace( '{y}', elm.oCarousel.numberOfSlides );
			previousButton.setAttribute( 'aria-label', previousButtonLongText );
			previousButton.setAttribute( 'aria-controls', elm.oCarousel.settings.uniqueId + '-slide' + previousPageIndex );

			elm.oCarousel.previousPageIndex = previousPageIndex;
		},

		updateNextButton : function( elm, slideIndex ) {
			var nextButton = elm.oCarousel.nextButton.firstChild,
				nextPageIndex,
				nextButtonLongText;

			if ( slideIndex >= elm.oCarousel.numberOfSlides - 1 ) {
				nextPageIndex = elm.oCarousel.numberOfSlides - 1;
				nextButton.disabled = true;
			} else {
				nextPageIndex = slideIndex + 1;
				nextButton.removeAttribute( 'disabled' );
			}

			nextButtonLongText = elm.oCarousel.settings.labels.nextPageLong.replace( '{x}', nextPageIndex + 1 );
			nextButtonLongText = nextButtonLongText.replace( '{y}', elm.oCarousel.numberOfSlides );
			nextButton.setAttribute( 'aria-label', nextButtonLongText );
			nextButton.setAttribute( 'aria-controls', elm.oCarousel.settings.uniqueId + '-slide' + nextPageIndex );

			elm.oCarousel.nextPageIndex = nextPageIndex;
		},

		setPaginationListener : function( elm, buttonElm, slideIndex ) {
			buttonElm.addEventListener( 'click', function listener() {
				oCarouselFn.setSlidePosition( elm, slideIndex );
			});
		},
	};

	return {
		initInstance : function( elm, extras ) {
			return oCarouselFn.init( elm, extras );
		},
	};
});
